import pkg from '../../package.json' with { type: 'json' }

const BUILD_DATE = import.meta.env.VITE_BUILD_DATE || new Date().toISOString()

export function getBuildInfo(): { version: string; date: string } {
  const date = new Date(BUILD_DATE)
  const formatted = date
    .toLocaleDateString('en-US', {
      month: 'short',
      day: '2-digit',
      year: 'numeric',
    })
    .toUpperCase()

  return {
    version: pkg.version,
    date: formatted,
  }
}
